import {createFileRoute, Navigate} from '@tanstack/react-router'

function IndexComponent() {
	return <Navigate to='/today' />
}

export const Route = createFileRoute('/')({
	component: IndexComponent,
})
